module.exports = __webpack_public_path__ + "static/img/RS2761_1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/produkty/RS2761_1.png
// module id = nfW4
// module chunks = 0